import React from 'react';

const Title = () => {
	return (
		<div className="main__title">
			<h2>Bus tickets</h2>
			<span className='main__title-countries'>across Ukraine and Europe</span>
		</div>
	);
}

export default Title;
